module.exports = __webpack_public_path__ + "static/img/Zhen_Xin_Chair.4fae69de.png";